import { AccountResponse } from '../../store/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
  account: AccountResponse | null;
};

const initialState: State = { account: null };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccount(state: State, action: PayloadAction<AccountResponse>) {
      state.account = action.payload;
    },
    logout(state: State) {
      state.account = null;
    },
  },
});

const { reducer } = authSlice;
export default reducer;
export const authActions = authSlice.actions;
